import(/* webpackMode: "eager" */ "/codebuild/output/src2523820579/src/rmh-platform/apps/rmh-patient/app/global-error.tsx");
